import * as react_components from "../reactcomponent.js"
import { PropertyTypes, WidthProperty } from "../property_types.js"
import React from "react";
export class MatrixComponent extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleDataChange = (data) => {
        this.setState({ data: data });
    }

    renderHeader = (data) => {
        var style: React.CSSProperties = { "textAlign": "center", "fontSize": "14px" };
        if (this.props.settings.get('categoryAxis')) {
            return <th style={style}>{data[this.props.settings.get('categoryAxis').get('field')]}</th>
        }
        return <th>...</th>
    }

    renderSeries = (series) => {
        var style: React.CSSProperties = { "textAlign": "center", "fontSize": "14px" };
        if (series.get('color')) {
            style["background-color"] = series.get('color');
        }
        var values = this.state.data.map(function (data) {
            var num = data[series.get('field')];
            if ($.isNumeric(num)) {
                num = Math.round(num);
            }
            return <td style={style}>{num}</td>
        })

        return (<tr><td>{series.get('name')}</td>{values}</tr>)
    }

    renderComponent = (data) => {
        if (!Array.isArray(this.state.data)) {
            return null;
        }

        var header = this.state.data.map(this.renderHeader);
        var series = this.props.settings.get('series').map(this.renderSeries);
        var tableStyle: React.CSSProperties = { tableLayout: "fixed", width: "100%", borderCollapse: "collapse", pageBreakInside: "avoid" };

        return (<table style={tableStyle} className="table table-bordered table-hover dataTable">
            <tbody>
                <tr>
                    <th style={{ width: this.props.settings.get('firstColumnWidth') + "px" }}></th>
                    {header}
                </tr>
                {series}

            </tbody>
        </table>)
    }

    render() {
        var dataComp = this.renderComponent(this.state.data);

        return (<react_components.ReactColumn width={this.props.settings.get('width')} >
            <react_components.ReactDataPager titel={this.props.settings.titel}
                context={this.props.context}
                dataUrl={this.props.settings.get('dataUrl')}
                enablePagging={true}
                pageSize={Number(this.props.settings.pageSize)}
                queryParameter={this.props.queryParameter}
                onVisibleDataChange={this.handleDataChange}>
                {dataComp}
            </react_components.ReactDataPager>
        </react_components.ReactColumn>)
    }
};


export var matrixComponentEditorConfig = [
    { Type: "TEXT", ValueField: "name", Label: "Name" },
    WidthProperty,
    { Type: "TEXT", ValueField: "pageSize", Label: "Page size" },
    { Type: "SERVICESELECTOR", ValueField: "dataUrl", Label: "DataUrl" },
    { Type: "TEXT", ValueField: "firstColumnWidth", Label: "FirstColumnWidth" },
    {
        Type: "OBJECT", ValueField: "categoryAxis", Label: "Category axis", Properties: [
            { Type: "TEXT", ValueField: "field", Label: "Field" }
        ]
    },
    {
        Type: "OBJECT_LIST", ValueField: "series", Label: "Series", Properties: [
            { Type: "TEXT", ValueField: "field", Label: "Field" },
            { Type: "TEXT", ValueField: "color", Label: "Color" },
            { Type: "TEXT", ValueField: "name", Label: "Name" }
        ]
    }

];

